import { browserHistory } from 'react-router';

export default (() => {

    function push(url) {

        browserHistory.push(url);
    }

    return {
        push
    };

})();


// WEBPACK FOOTER //
// ./services/navigator.js